import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Dialog from '../../../../../core/layout/Dialog';
import Button from '../../../../../core/form/Button';
import Row from '../../../../../core/layout/Row';
import Column from '../../../../../core/layout/Column';
import FetchSelect from '../../../../../core/form/FetchSelect';

const MoveUnitItemFormDialog = (props) => (
  <Dialog
    title="Shift selected items to unit below"
    isOpen={props.isOpen}
    onCancel={props.onCancel}
    width={800}
    actions={[
      <Button
        key="cancel"
        label="Cancel"
        icon="reload"
        disabled={props.submitting}
        loading={props.submitting}
        onClick={props.onCancel}
      />,
      <Button
        key="confirm"
        label="Confirm"
        icon="check"
        disabled={props.submitting}
        loading={props.submitting}
        onClick={props.onConfirm}
      />,
    ]}
  >
    <Row>
      <Column size={4}>
        <FetchSelect
          showSearch
          url="courses"
          disabled={props.submitting}
          label="Course"
          value={get(props.values, 'course', '')}
          onChange={(module) => props.onChange('course', module)}
          errorText={get(props.errors, 'course', '')}
          required
          sortCondition={['order']}
          resultFilter={(course) => {
            course.order = [
              'Discovery',
              'Adventures',
              'Pre A1',
              'A1',
              'A1+',
              'A2',
              'A2+',
              'B1',
              'B1+',
              'B2',
              'B2+',
              'C1',
              'C1+',
              'C2',
            ].indexOf(course.name);
            return true;
          }}
          resultTransformer={{
            text: 'name',
            value: 'id',
          }}
        />
      </Column>
      <Column size={4}>
        <FetchSelect
          showSearch
          url={props.values.course && `modules?query[course]=${props.values.course}`}
          disabled={props.submitting || !props.values.course}
          label="Module"
          value={get(props.values, 'module', '')}
          onChange={(module) => props.onChange('module', module)}
          errorText={get(props.errors, 'module', '')}
          required
          sortCondition={['order']}
          resultTransformer={{
            text: 'name',
            value: 'id',
          }}
        />
      </Column>
      <Column size={4}>
        <FetchSelect
          showSearch
          url={props.values.module && `modules/${props.values.module}/units`}
          disabled={props.submitting || !props.values.module}
          label="Unit"
          value={get(props.values, 'unit', '')}
          onChange={(module) => props.onChange('unit', module)}
          errorText={get(props.errors, 'unit', '')}
          required
          sortCondition={['order']}
          resultTransformer={{
            text: 'name',
            value: 'id',
          }}
        />
      </Column>
    </Row>
  </Dialog>
);

MoveUnitItemFormDialog.propTypes = {
  values: PropTypes.object,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.object,
  submitting: PropTypes.bool,
  isOpen: PropTypes.bool,
};

MoveUnitItemFormDialog.defaultProps = {
  values: {},
  errors: {},
  submitting: false,
  isOpen: false,
};

export default MoveUnitItemFormDialog;
